import { Image } from "react-native";

import { Country } from "./types";

function url(logoName: string) {
  const uri = `https://cuanto-flags.sfo2.cdn.digitaloceanspaces.com/${logoName}.jpeg`;
  Image.prefetch(uri); // save for later
  return uri;
}

export const COUNTRY_LIST: Country[] = [
  {
    name: "Costa Rica",
    logo: { uri: url("costarica") },
    logoName: "costarica",
    code: "506",
    usersCanReceivePayouts: true,
  },
  {
    name: "El Salvador",
    logo: { uri: url("salvador") },
    logoName: "salvador",
    code: "503",
  },
  {
    name: "Ecuador",
    logo: { uri: url("ecuador") },
    logoName: "ecuador",
    code: "593",
  },
  {
    name: "Guatemala",
    logo: { uri: url("guatemala") },
    logoName: "guatemala",
    code: "502",
  },
  {
    name: "Panamá",
    logo: { uri: url("panama") },
    logoName: "panama",
    code: "507",
    usersCanReceivePayouts: true,
  },
];

export const COUNTRY_MAP = {
  panama: COUNTRY_LIST[4],
};

const SUPPORTED_COUNTRY_CODES = COUNTRY_LIST.map((c) => c.code);
